// extracted by mini-css-extract-plugin
export default {"container":"Warning_container__Om+lR","warning":"Warning_warning__y99Vj","link":"Warning_link__QToYf"};